import { createContext, useState, useEffect } from "react";

import dayjs from "dayjs";

import useAxios from "../../utils/useAxios";
import { resObj } from "../../utils/constants";

const MixingContext = createContext();

export default MixingContext;

export const MixingProvider = ({ children }) => {
  const api = useAxios();

  const initialValues = {
    today: dayjs(Date.now()),
    operatorArray: [],
    solventArray: [],
    lipidStocksArray: [],
    robotArray: ['Janus', 'Ignite'],
    defaultRobot: 'Janus',
  };
  const [apiRes, setApiRes] = useState(resObj);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [formulationsObj, setFormulationsObj] = useState({
    type: 'Plate', ids: [],
  });
  const [formulationsArray, setFormulationsArray] = useState([]);
  const [robot, setRobot] = useState(initialValues?.defaultRobot);
  const [status, setStatus] = useState({success: false, msg: ''});

  const getRobotStatus = async () => {
    try {      
      setApiRes({...apiRes, loading: true});
      const response = await api.get(
        '/api/materials-capture/mixing/robot/status/get', {
          params: {
            formulation_type: formulationsObj?.type,
            id_list: formulationsObj?.ids.map(item => +item.id),
            robot_type: robot,
          }
        });
      
      if (response.status === 200) {
        setStatus(prev => ({
          ...prev,
          success: response.data.success,
          msg: response.data.msg,
        }));
        setApiRes({ ...apiRes, loading: false });
      }
    } catch (err){
      setApiRes({
        ...apiRes,
        axiosError: true,
        errMsg: JSON.stringify(err.response.data).replace(/[{}[\]"']/g, ''),
        errHeading: 'Mixing Robot Status Get',
        loading: false,
      });
    }
  };

  const validate = () => {
    const errors = {};
    if (formulationsObj?.ids.length === 0) {
      errors['formulation'] = `${formulationsObj?.type} is required!`;
    }
    return errors;
  };

  const handleSubmit = () => {
    setFormErrors(validate());
    setIsSubmit(true);
  };

  useEffect(() => {    
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      getRobotStatus();
    }
  }, [formErrors]);
  
  useEffect(() => {
    getFormulations();
  }, [formulationsObj?.type]);

  const getFormulations = async () => {
    try {
      setApiRes({...apiRes, loading: true});
      const response = await api.get(
        '/api/materials-capture/formulations/data/get', {
          params: { formulation_type: formulationsObj?.type }
        }
      );
      
      if (response.status === 200) {
        setFormulationsArray(response.data);
        setApiRes({ ...apiRes, loading: false });
      }
    } catch (err){
      setApiRes({
        ...apiRes,
        axiosError: true,
        errMsg: JSON.stringify(err.response.data).replace(/[{}[\]"']/g, ''),
        errHeading: 'Formulations Data Get',
        loading: false,
      });
    }
  };

  const handleTypeChange = e => {
    setFormulationsObj(prev => ({
      ...prev,
      type: e.target.value,
      ids: [],
    }));    
  };

  const contextData = {
    initialValues: initialValues,
    formErrors: formErrors,
    handleSubmit: handleSubmit,
    apiRes: apiRes,
    setApiRes: setApiRes,
    formulationsObj: formulationsObj,
    setFormulationsObj: setFormulationsObj,
    formulationsArray: formulationsArray,
    setFormulationsArray: setFormulationsArray,
    handleTypeChange: handleTypeChange,
    robot: robot,
    setRobot: setRobot,
    status: status,
  };

  return (
    <MixingContext.Provider value={contextData}>
      {children}
    </MixingContext.Provider>
  )
};